import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {FilterCriterionMultiselect} from '../../../models/filters/filter-criterion-input';

@Component({
    selector: 'multiselect-search-input',
    templateUrl: './multiselect-search-input.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MultiselectSearchInputComponent {

    @Input()
    public searchFilter: FilterCriterionMultiselect;

    @Output()
    public readonly filterChange = new EventEmitter();

}
